import { useGoalUpdateMutation } from "web_myplann/Api/Goals/useGoalUpdateMutation";
import { mapGoalOwnFundsToUpdateRequest } from "web_myplann/Goals/Mappers/mapGoalOwnFundsToUpdateRequest";
import type { GoalDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";

type UseSetOwnFundsParams = {
	goalId: number | null;
	goalDto: GoalDetailResponseDTO | undefined;
	onSaved: () => void;
};

export const useSetOwnFunds = ({
	goalId,
	goalDto,
	onSaved,
}: UseSetOwnFundsParams) => {
	const { mutate: updateGoal, isPending } = useGoalUpdateMutation();

	const saveOwnFunds = (ownFunds: number) => {
		if (goalId === null || !goalDto) return;

		const body = mapGoalOwnFundsToUpdateRequest(goalDto, ownFunds);
		if (!body) return;

		updateGoal({ id: goalId, body }, { onSuccess: onSaved });
	};

	return { saveOwnFunds, isSaving: isPending };
};
